import { URI } from '@/config/config';
import { SHA256 } from 'crypto-js';

export default async ({ commit }, { cpf, password }) => {
  const pass = SHA256(password).toString();

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      cpf,
      password: pass,
      from: 'manager',
    }),
  };

  const userLoginInfoResult = await fetch(`${URI}user/employee-login`, opts);
  const jsonResult = await userLoginInfoResult.json();
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  commit('setAccessData', jsonResult.user);
  commit('setToken', jsonResult);

  return jsonResult;
};
